




































































































































import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import {$, ID, successAndPush} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'

const metaInfo = () => ({
  title: $.t('view.persist.userPersist.title'),
})

@Component({
  metaInfo,
})
export default class OccurrenceTypePersistView extends Vue {
  @Prop({type: [String, Number]}) id?: ID

  AppConfig = AppConfig

  listToPersist: TipoOcorrencia[] = []

  get editMode() {
    return Boolean(this.id)
  }

  created() {
    this.$set(this.listToPersist, 0, new TipoOcorrencia())
  }

  async mounted() {
    if (this.id) await this.listToPersist[0].getTipoOcorrencia(this.id)
    $.await.done('getOccurrenceType')
  }

  addItem() {
    this.listToPersist.push(new TipoOcorrencia())
  }

  removeItem(item: TipoOcorrencia) {
    const index = this.listToPersist.indexOf(item)
    if (index > -1) {
      this.listToPersist.splice(index, 1)
      this.$forceUpdate()
    }
  }

  clearTrajeto(idx: number) {
    this.listToPersist[idx].ehTrajeto = false
  }

  clearDevolvida(idx: number) {
    this.listToPersist[idx].ehDevolvida = false
  }

  async persist() {
    await TipoOcorrencia.persistLoteTipoOcorrencia(this.listToPersist)
    successAndPush('system.success.persist', '/manage/occurrence-type/list')
  }
}
